import { Controller } from "@hotwired/stimulus"
import Rails from "@rails/ujs"
import { successDialog, errorDialog } from "../helpers/swal_helper"

export default class extends Controller {
  static targets = ["rewardType", "comment", "level", "submitBtn"]

  connect() {
  }

  fireConfetti() {
    if (window.fireConfetti) {
      window.fireConfetti()
    }
  }

  submitReward(event) {
    event.preventDefault()

    const rewardTypeId = this.rewardTypeTarget.value
    const comment = this.commentTarget.value
    const levelId = this.element.querySelector('input[name="level_id"]:checked')?.value
    const studentId = this.element.dataset.studentId

    if (!rewardTypeId) {
      errorDialog("Error", "Please select a reward type")
      return
    }

    this.submitBtnTarget.disabled = true

    Rails.ajax({
      url: '/reward_given',
      type: 'GET',
      dataType: 'json',
      data: new URLSearchParams({
        student_id: studentId,
        reward_type_id: rewardTypeId,
        comment: comment,
        level_id: levelId
      }),
      success: (data) => {
        if (data.success) {
          this.fireConfetti()
          successDialog("Alḥamdulillāh", "Reward given successfully!")
          $('#rewardModal').modal('hide')
          setTimeout(() => location.reload(), 1500)
        } else {
          errorDialog("Error", data.errors || "Failed to give reward")
          this.submitBtnTarget.disabled = false
        }
      },
      error: () => {
        errorDialog("Error", "Failed to give reward. Please try again.")
        this.submitBtnTarget.disabled = false
      }
    })
  }
}
